export default {"src":"/_next/static/media/orange-enterprise.807a0899.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};